import React from "react";
import { FaSpinner } from "react-icons/fa";

const StepFooterNav = ({ onBack, onNext, nextLabel = "Continue", backLabel = "Back", showBack = true, isNextLoading = false, disabled = false, backDisabled = false }) => {
    return (
        <div className="d-flex justify-content-between">
            <button
                type="button"
                className="btn custom-sumbitbtn"
                style={{ order: 2 }}
                onClick={onNext}
                disabled={isNextLoading || disabled}
            >
                {isNextLoading ? <FaSpinner className="fa-spin" /> : nextLabel}
            </button>
            {showBack ? (
                <button
                    type="button"
                    className="btn hvt-back-btn-soft d-flex align-items-center gap-1"
                    style={{ order: 1 }}
                    onClick={onBack}
                    disabled={backDisabled}
                >
                    {backLabel}
                </button>
            ) : <span style={{ order: 1 }} />}
        </div>
    );
};

export default StepFooterNav;
